import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import * as React from 'react';
import styled from 'styled-components';
import { space, color, lineHeight, fontSize } from '@core-ds/primitives';
import Label from './label.js';
import { Checkbox } from '@ifixit/toolbox';
import { _js } from '@ifixit/localize';
var ProductLabelWithCheckbox = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   color: ", ";\n   font-size: ", ";\n   text-align: left;\n   font-weight: bold;\n   line-height: ", ";\n   margin-bottom: ", ";\n   display: block;\n   position: relative;\n   cursor: pointer;\n"])), function (props) {
  return props.isSelected ? color.gray[800] : color.gray[500];
}, fontSize.lg, lineHeight.tight, space[2]);
var checkboxMargin = space[2];
var ThisItem = styled(Label)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   margin-right: ", ";\n"])), checkboxMargin);
var Price = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   color: ", ";\n   padding: 0 5px;\n   font-weight: normal;\n"])), function (props) {
  return props.isSelected ? color.red[500] : color.gray[500];
});
var StyledLink = styled.a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   cursor: pointer;\n   color: inherit;\n   text-decoration: none !important;\n"])));

function SelectableProduct(_ref) {
  var product = _ref.product,
      isSelected = _ref.isSelected,
      isInitialProduct = _ref.isInitialProduct,
      onSelectedChange = _ref.onSelectedChange,
      formatPrice = _ref.formatPrice;
  return /*#__PURE__*/React.createElement(ProductLabelWithCheckbox, {
    isSelected: isSelected(product)
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSelected(product),
    labelMargin: checkboxMargin,
    onChange: function onChange(_ref2) {
      var checked = _ref2.checked;
      return onSelectedChange(product.sku, checked);
    }
  }, isInitialProduct && /*#__PURE__*/React.createElement(ThisItem, null, _js('This Item')), product.link ? /*#__PURE__*/React.createElement(StyledLink, {
    href: product.link
  }, product.name) : /*#__PURE__*/React.createElement("span", null, product.name), /*#__PURE__*/React.createElement(Price, {
    isSelected: isSelected(product)
  }, formatPrice(product.price))));
}

function SelectableProductList(_ref3) {
  var initialProduct = _ref3.initialProduct,
      relatedProducts = _ref3.relatedProducts,
      isSelected = _ref3.isSelected,
      onSelectedChange = _ref3.onSelectedChange,
      formatPrice = _ref3.formatPrice;
  return /*#__PURE__*/React.createElement(React.Fragment, null, relatedProducts.map(function (product, key) {
    return /*#__PURE__*/React.createElement(SelectableProduct, {
      product: product,
      isSelected: isSelected,
      isInitialProduct: product.sku === initialProduct.sku,
      onSelectedChange: onSelectedChange,
      formatPrice: formatPrice,
      key: key
    });
  }));
}

export default SelectableProductList;